import React from "react"
import { Error } from "@bancacfplus/Error"
import style from "./ErrorBoundaryEnriched.module.scss"
import { AxiosError } from "axios"
import { ErrorLike } from "@apollo/client"

export function XFConnectionError() {
  return (
    <Error>
      <div className={style.container}>
        <b>Servizio temporaneamente non disponibile</b>
        <br></br>
        <div>
          Stiamo effettuando un intervento di manutenzione programmata.
          <br />
          Ti invitiamo a riprovare più tardi.
        </div>
      </div>
    </Error>
  )
}

// Central registry of known error matchers
const errorMatchers: Array<{
  match: (error: Error | AxiosError | ErrorLike | undefined) => boolean
  component: React.FC
}> = [
  {
    match: err => !!err && err.message.includes("ERRORE DI CONNESSIONE CON AS/400"),
    component: XFConnectionError
  }
]

// Export a helper that finds a matching component
export function getCustomErrorComponent(error: Error | AxiosError | ErrorLike | undefined) {
  const match = errorMatchers.find(rule => rule.match(error))
  return match?.component ?? null
}
